/* Links distinctive individual ribbons back to their combo packs. */
(function () {
  var script = document.currentScript;
  var info = script && script.closest('[id^="ProductInfo-"]');
  if (!info) info = document.querySelector('[id^="ProductInfo-"]');
  if (!info || info.querySelector('.rf-combo-source-links')) return;

  var choices = [
    ['Italian Side Street', '1-1/2"', '/products/gstblacom', 'Black & White Stripe #1 Combo Pack'],
    ['Out on the Town', '1-1/2"', '/products/gxhol5com', 'Christmas Stripe #5 Combo Pack'],
    ['Modern Holly-Day', '1-1/2"', '/products/christmas-stripe-6-combo-pack-in-emerald-red-gold-modern-holly-day-red-gold-holiday', 'Christmas Stripe #6 Combo Pack'],
    ['American Flag', '7/8"', '/products/gpat1com', 'Patriotic #1 Combo Pack'],
    ['Red/White/Royal Blue', '7/8"', '/products/gpat1com', 'Patriotic #1 Combo Pack'],
    ['Cinnamon Sweetie', '7/8"', '/products/gval1com', 'Valentine Stripe #1 Combo Pack'],
    ['Sweetheart Stitch', "7/8'", '/products/gval1com', 'Valentine Stripe #1 Combo Pack']
  ];
  var card = document.createElement('nav');
  card.className = 'rf-combo-source-links';
  card.id = 'rf-combo-source-links-' + info.id;
  card.setAttribute('aria-label', 'Find this ribbon in a combo');
  card.hidden = true;
  var heading = document.createElement('span');
  heading.textContent = 'Find this ribbon in a combo';
  card.appendChild(heading);
  var links = document.createElement('div');
  choices.forEach(function (choice) {
    var link = document.createElement('a');
    link.dataset.rfColor = choice[0];
    link.dataset.rfWidth = choice[1];
    link.href = choice[2];
    link.textContent = choice[3] + ' →';
    link.hidden = true;
    links.appendChild(link);
  });
  card.appendChild(links);
  info.appendChild(card);

  var style = document.createElement('style');
  style.textContent = '.rf-combo-source-links{box-sizing:border-box;margin:1rem 0 1.5rem;padding:1.2rem 1.4rem;border:1px solid #d4e3d1;border-left:4px solid #5b805f;border-radius:.8rem;background:#f5f8f3;color:#2f4c35;scroll-margin-top:9rem}' +
    '.rf-combo-source-links[hidden],.rf-combo-source-links a[hidden]{display:none!important}' +
    '.rf-combo-source-links span{display:block;margin-bottom:.7rem;font-size:1.1rem;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:#5b755f}' +
    '.rf-combo-source-links>div{display:flex;flex-wrap:wrap;gap:.6rem}' +
    '.rf-combo-source-links>div>a{display:inline-flex;align-items:center;min-height:44px;padding:.65rem .9rem;border:1px solid #c5d7c1;border-radius:.55rem;background:#fff;color:#31583a;font-size:1.2rem;font-weight:700;text-decoration:none}' +
    '.rf-combo-source-links>div>a:hover{background:#eaf2e8;text-decoration:underline}' +
    '.rf-combo-related-panel>.rf-combo-source-links{margin:0;background:#fff}' +
    '@media(max-width:749px){.rf-combo-source-links>div>a{width:100%}.rf-combo-source-links .rf-related-back{display:inline-flex;width:auto;min-height:30px;margin-top:1rem}}';
  info.appendChild(style);

  var jump = document.createElement('a');
  jump.className = 'rf-related-jump';
  jump.id = 'rf-combo-source-jump-' + info.id;
  jump.href = '#' + card.id;
  jump.textContent = 'View Combo Pack ↓';
  var back = document.createElement('a');
  back.className = 'rf-related-back';
  back.textContent = 'Back to options ↑';

  function option(name) {
    var field = Array.from(info.querySelectorAll('variant-selects fieldset')).find(function (item) {
      return item.querySelector('legend')?.textContent.trim().toLowerCase() === name;
    });
    return field?.querySelector('input:checked')?.value || '';
  }
  function sync() {
    var color = option('color');
    var width = option('width');
    var found = false;
    links.querySelectorAll('a').forEach(function (link) {
      var match = link.dataset.rfColor === color && link.dataset.rfWidth === width;
      link.hidden = !match;
      if (match) found = true;
    });
    card.hidden = !found;
    if (!found) {
      jump.remove();
      back.remove();
      return;
    }
    var phone = window.matchMedia('(max-width:749px)').matches;
    var description = info.querySelector('.product__description') || info.querySelector('.rf-nonwired-fact');
    var panel = info.querySelector('.rf-combo-related-panel');
    if (phone) {
      if (panel && description) {
        panel.insertAdjacentElement('beforebegin', description);
        description.insertAdjacentElement('afterend', card);
        panel.remove();
      }
      var buy = info.querySelector('.rf-buy-focus') || info.querySelector('.hcp-purchase-payment-row') || info.querySelector('product-form')?.parentElement;
      var stableSpecialtyPhone = /\/specialty-stripes-ribbon$/.test(info.closest('product-info')?.dataset.url || '') && description?.matches('.product__description');
      if (stableSpecialtyPhone) {
        if (card.nextElementSibling !== description) description.insertAdjacentElement('beforebegin', card);
      } else {
      var anchor = description?.matches('.product__description') ? description : buy;
      if (anchor && card.previousElementSibling !== anchor) anchor.insertAdjacentElement('afterend', card);
      }
      card.style.order = '';
      var nearTitle = info.querySelector('.rf-mobile-jump-links') || info.querySelector('.rf-plural-menu-heading') || info.querySelector('.product__title');
      if (nearTitle && jump.previousElementSibling !== nearTitle) nearTitle.insertAdjacentElement('afterend', jump);
      var target = Array.from(info.querySelectorAll('variant-selects legend,variant-selects .form__label')).find(function (item) {
        return item.textContent.trim().toLowerCase() === 'color';
      }) || info.querySelector('variant-selects legend');
      if (target) {
        if (!target.id) target.id = 'rf-product-options-target-' + info.id;
        back.href = '#' + target.id;
      }
      if (back.parentElement !== card) card.appendChild(back);
    } else {
      jump.remove();
      back.remove();
      card.style.order = '';
      if (description) {
        if (!panel) {
          panel = document.createElement('div');
          panel.className = 'rf-related-combined-panel rf-combo-related-panel';
          description.insertAdjacentElement('beforebegin', panel);
          panel.appendChild(description);
        }
        if (card.parentElement !== panel || card.previousElementSibling !== description) description.insertAdjacentElement('afterend', card);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true });
  else sync();
  window.addEventListener('load', sync);
  window.addEventListener('resize', sync);
  document.addEventListener('change', function () { requestAnimationFrame(sync); window.setTimeout(sync, 150); }, true);
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('rf:choices-updated', sync);
  for (var n = 1; n <= 20; n++) window.setTimeout(sync, n * 250);
})();
